const appConfig = {
    // Only in dev mode
    isDev: process.env.NODE_ENV === 'development',
    useReduxLogger: process.env.NODE_ENV === 'development',
    useReduxDevTools: process.env.NODE_ENV === 'development',
    // Not in dev mode
    useSentry: process.env.NODE_ENV !== 'development',
    useCrashReporter: process.env.NODE_ENV !== 'development',
};

export default appConfig;
